import Cookies from 'js-cookie';

document.addEventListener('preloaded', function () {
    const alerts = $('.neos-frontend .alert-container');

    if (alerts.length > 0) {
        alerts.each(function () {
            const alert = this;
            const alertId = alert.getAttribute('data-alert-id');
            const expires = Number(alert.getAttribute('data-alert-expires'));
            const alertCookie = Cookies.get(alertId);
            const alertCloseBtn = $(alert).find('.btn-close-alert');

            // Hide alert if has cookie and is dismissable
            if (alertCookie && alertCloseBtn.length > 0) {
                $(alert).addClass('d-none');
                $(alert).parents('.section').addClass('d-none');
            } else {
                $(alert).parents('.section').removeClass('d-none');
            }

            // Set cookie to alert if closed that expires in
            if (alertCloseBtn.length > 0) {
                $(alert).find('.btn-close-alert').on('click', function () {
                    $(alert).addClass('d-none');

                    Cookies.set(alertId, 'expiresIn', { expires: expires });
                });
            }
        });
    }
});
